import { makeActionCreator } from '../../../utilities'
import { CustomSignaturesConstants } from './customSignature.constants'

export const setCustomSignatureOptions = makeActionCreator(
  CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_TRANSFORMED_OPTIONS,
  'customSignatureTranformedOptions'
)
export const setCurrentSelectedOption = makeActionCreator(
  CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_CURRENT_SELECTED_OPTION,
  'currentSelectedOption'
)
export const setSigningReason = makeActionCreator(
  CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_SIGNING_REASON,
  'signingReason'
)
export const setSignatoryName = makeActionCreator(
  CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_SIGNATORY_NAME,
  'signatoryName'
)
export const setSignatoryRelation = makeActionCreator(
  CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_SIGNATORY_RELATION,
  'signatoryRelation'
)
export const setSignatoryPhone = makeActionCreator(
  CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_SIGNATORY_PHONE,
  'signatoryPhone'
)
export const setCounter = makeActionCreator(CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_COUNTER, 'counter')
export const saveTempSignature = makeActionCreator(CustomSignaturesConstants.SAVE_TEMP_SIGNATURE, 'tempSignature')
export const saveCustomSignatures = makeActionCreator(
  CustomSignaturesConstants.SAVE_CUSTOM_SIGNATURE,
  'prFormsSignature'
)
export const saveCustomSignatureToPcr = makeActionCreator(CustomSignaturesConstants.SAVE_CUSTOM_SIGNATURE_TO_PCR)
export const savePrFormsCustom = makeActionCreator(CustomSignaturesConstants.SAVE_PR_FORMS_CUSTOM, 'prFormsCustom')
export const addCustomSignature = makeActionCreator(CustomSignaturesConstants.ADD_CUSTOM_SIGNATURE)
export const setCustomAcknowledgePrivacyNotice = makeActionCreator(
  CustomSignaturesConstants.SET_SELECTED_CHECKBOX,
  'acknowledgePrivacyNotice'
)
export const setacknowledgedPrivacyNotices = makeActionCreator(
  CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_ACKNOWLEDGED_PRIVACY_NOTICES,
  'acknowledgedPrivacyNotices'
)
export const setCustomSignatureTerm = makeActionCreator(CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_TERM, 'term')
export const setSignedCustomSignature = makeActionCreator(
  CustomSignaturesConstants.SET_SIGNED_CUSTOM_SIGNATURE,
  'signature'
)
export const resetCustomSignatureClientData = makeActionCreator(
  CustomSignaturesConstants.RESET_CUSTOM_SIGNATURE_CLIENT_DATA
)
export const loadCustomSignatureData = makeActionCreator(
  CustomSignaturesConstants.LOAD_CUSTOM_SIGNATURE_DATA,
  'prFormsSignatureObj'
)
export const setDeleteChipId = makeActionCreator(CustomSignaturesConstants.SET_DELETE_CHIP_ID, 'deleteChipId')
export const customSignatureClearAll = makeActionCreator(CustomSignaturesConstants.CUSTOM_SIGNATURE_CLEAR_ALL)
export const setCustomSignatureClientData = makeActionCreator(
  CustomSignaturesConstants.SAVE_CUSTOM_SIGNATURE_CLIENT_DATA,
  'customSignatureClientData'
)

export const setSignatureType = makeActionCreator(CustomSignaturesConstants.SET_SIGNATURE_TYPE, 'signatureType')
export const resetCustomSignature = makeActionCreator(CustomSignaturesConstants.RESET_CUSTOM_SIGNATURE)
